import './page-sidebar.scss'


// WEBPACK FOOTER //
// ./app/theme/components/page-sidebar/page-sidebar.js